import React, { Component } from 'react';
import '../../../../styles/variables.css';
import './DashMain.css';
import {Col} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import profile from '../../../../images/c_logo.png';
import amz from '../../../../images/amazon.png';
import goo from '../../../../images/google.png';
import git from '../../../../images/github.png';

class MainContent extends Component {

    render(){
        return(
            <div className="container dashMain">
                <Col xs={12} sm={12} md={11} lg={11} xl={11} className="dash-card-title no-float mx-auto">
                    <div className="dahs-resume">
                        <div className="actualVacancies">
                            <p className="dtext"><span aria-label="" role="img">🔶</span> Total de Vacantes en Curso</p>
                            <p className="total-text">8</p>
                        </div>
                        <div className="actualRequest">
                            <p className="dtext"><span aria-label="" role="img">🔻</span> Total de Solicitudes por Aprobar</p>
                            <p className="total-text">10</p>
                        </div>
                    </div>
                </Col>
                <Col xs={12} sm={12} md={11} lg={10} xl={10} className="cards-container no-float mx-auto">
                    <div className="dash-card-l">
                        <div className="dcard-title">
                            <p className="dc-title">Vacantes Publicadas</p>
                            <Link className="dlink" to="/">Ver más</Link>
                        </div>
                        <div className="dcard-content">
                            <img alt="profile" src={git} className="dcard-profile"/>
                            <div className="dcard-desc">
                                <p className="d-job-title">React Developer Jr.</p>
                                <p className="d-companyName">Axa Seguros</p>
                                <p className="d-hireName">Tiempo completo</p>
                                <p className="d-location">Urgente</p>
                            </div>
                        </div>
                        <div className="dcard-content">
                            <img alt="profile" src={amz} className="dcard-profile"/>
                            <div className="dcard-desc">
                                <p className="d-job-title">React Developer Jr.</p>
                                <p className="d-companyName">Axa Seguros</p>
                                <p className="d-hireName">Tiempo completo</p>
                                <p className="d-location">Urgente</p>
                            </div>
                        </div>
                        <div className="dcard-content">
                            <img alt="profile" src={git} className="dcard-profile"/>
                            <div className="dcard-desc">
                                <p className="d-job-title">React Developer Jr.</p>
                                <p className="d-companyName">Axa Seguros</p>
                                <p className="d-hireName">Tiempo completo</p>
                                <p className="d-location">Urgente</p>
                            </div>
                        </div>
                        <div className="dcard-content">
                            <img alt="profile" src={goo} className="dcard-profile"/>
                            <div className="dcard-desc">
                                <p className="d-job-title">React Developer Jr.</p>
                                <p className="d-companyName">Axa Seguros</p>
                                <p className="d-hireName">Tiempo completo</p>
                                <p className="d-location">Urgente</p>
                            </div>
                        </div>
                        <div className="dcard-content">
                            <img alt="profile" src={profile} className="dcard-profile"/>
                            <div className="dcard-desc">
                                <p className="d-job-title">React Developer Jr.</p>
                                <p className="d-companyName">Axa Seguros</p>
                                <p className="d-hireName">Tiempo completo</p>
                                <p className="d-location">Urgente</p>
                            </div>
                        </div>
                    </div>
                    <div className="dash-card">
                        <div className="dcard-title">
                            <p className="dc-title">Solicitudes por Aprobar</p>
                            <Link className="dlink" to="/">Ver más</Link>
                        </div>
                        <div className="dcard-content">
                            <img alt="profile" src={goo} className="dcard-profile"/>
                            <div className="dcard-desc">
                                <p className="d-job-title">React Developer Jr.</p>
                                <p className="d-companyName">Axa Seguros</p>
                                <p className="d-hireName">Tiempo completo</p>
                                <p className="d-location">Urgente</p>
                            </div>
                        </div>
                        <div className="dcard-content">
                            <img alt="profile" src={profile} className="dcard-profile"/>
                            <div className="dcard-desc">
                                <p className="d-job-title">React Developer Jr.</p>
                                <p className="d-companyName">Axa Seguros</p>
                                <p className="d-hireName">Tiempo completo</p>
                                <p className="d-location">Urgente</p>
                            </div>
                        </div>
                        <div className="dcard-content">
                            <img alt="profile" src={amz} className="dcard-profile"/>
                            <div className="dcard-desc">
                                <p className="d-job-title">React Developer Jr.</p>
                                <p className="d-companyName">Axa Seguros</p>
                                <p className="d-hireName">Tiempo completo</p>
                                <p className="d-location">Urgente</p>
                            </div>
                        </div>
                        <div className="dcard-content">
                            <img alt="profile" src={git} className="dcard-profile"/>
                            <div className="dcard-desc">
                                <p className="d-job-title">React Developer Jr.</p>
                                <p className="d-companyName">Axa Seguros</p>
                                <p className="d-hireName">Tiempo completo</p>
                                <p className="d-location">Urgente</p>
                            </div>
                        </div>
                        <div className="dcard-content">
                            <img alt="profile" src={profile} className="dcard-profile"/>
                            <div className="dcard-desc">
                                <p className="d-job-title">React Developer Jr.</p>
                                <p className="d-companyName">Axa Seguros</p>
                                <p className="d-hireName">Tiempo completo</p>
                                <p className="d-location">Urgente</p>
                            </div>
                        </div>
                    </div>
                </Col>
            </div>
        )
    }
}

export default MainContent;